import type { PublicFormField } from "../api/publicFormsApi";

/** Same label text as the native public form relation select options. */
export function getRelationOptionLabelFromField(
  field: Pick<PublicFormField, "fields">,
  option: unknown
): string {
  if (!option || typeof option !== "object") {
    return option != null ? String(option) : "";
  }
  const row = option as Record<string, unknown>;
  const rawFields = typeof field.fields === "string" ? field.fields : "";
  const fieldKeys = rawFields
    .split(",")
    .map((value) => value.trim())
    .filter(Boolean);
  if (fieldKeys.length > 0) {
    const parts = fieldKeys
      .map((key) => row[key])
      .filter(
        (value) => value !== undefined && value !== null && String(value).trim() !== ""
      )
      .map((value) => String(value));
    if (parts.length > 0) {
      return parts.join(" ");
    }
  }
  return (
    (row.name != null ? String(row.name) : "") ||
    (row.label != null ? String(row.label) : "") ||
    (row.title != null ? String(row.title) : "") ||
    (row.slug != null ? String(row.slug) : "") ||
    (row.uid != null ? String(row.uid) : "")
  );
}
